import styles from './secret-page-1.module.scss';
import { useState } from 'react';
import { Col, Row } from 'reactstrap';
import PageTitle from '../page-title/page-title';
import { makeRequest, useGetRequestNewHook } from '../requestUtils';
import { booleanHeader, Box, Button, Container, CreateHeaders, dateHeader, ErrorButton, Icon, MenuItem, OrderTypesEnum, Select, SuccessButton, textHeader } from '@frontend-workspace/react-shared-lib';
import { WebkuaTable } from '@frontend-workspace/webkua-lib';
import { useTranslation } from 'react-i18next';
import { OrderTypeEnum } from '../_enums/order-type';
import { TextField } from '@mui/material';

/* eslint-disable-next-line */
export interface SecretPage1Props { }

interface ISecretPageResponse {
  data: Array<any>,
  headers: Array<{ name: string, displayName: string, type: string }>,
  description: string
}

export function SecretPage1(props: SecretPage1Props) {
  const { t } = useTranslation();

  enum pageEnums {
    page0 = "undefined",
    page1 = "admin/secretpage1",
    page2 = "admin/secretpage2",
    page3 = "admin/secretPage3",
    page4 = "admin/secretPage4",
    page5 = "admin/secretPage5",
    page6 = "admin/secretPage6",
    page7 = "admin/secretPage7",
    page8 = "admin/secretPage8",
    page9 = "admin/secretPage9",
    page10 = "admin/secretPage10",
    page11 = "admin/secretPage11",
    page12 = "admin/secretPage12"
  }

  const [url, setUrl] = useState<string>("undefined");
  const { data, getData }: { data: ISecretPageResponse, getData: () => void } = useGetRequestNewHook(url, { data: [], headers: [], description: "Henter data..." }, [url]);
  const [importSheet, setImportSheet] = useState<undefined | any>(undefined);
  const [orderId, setOrderId] = useState<string>("");
  const [orderType, setOrderType] = useState<string>(OrderTypesEnum.SFChangeAssetOrder);
  const headers = CreateHeaders(data.headers.map(h => {
    if (h.type === "Boolean") return booleanHeader(h.name, h.displayName);
    if (h.type === "Date") return dateHeader(h.name, h.displayName);
    return textHeader(h.name, h.displayName);
  }));

  // const handleUpdateSecretPage = () => {
  //   makeRequest(`newAdmin/secretPage/action/updateSecretpage`, "PUT").then(getData);
  // };
  useGetRequestNewHook(`salesforce/products`, []);
  const handleUpdateSecretPage = () => {
    makeRequest("salesforce/Account", "PUT", {
      changedByEmail: "jon.magnus.nielsen@sogelink.com",
      companyName: "Jon's company",
      salesRepEmail: "jon.magnus.nielsen@sogelink.com",
      companyNumber: "60070",
      orgNr: "123456789",
      postAddress: {
        address: "Kongens gate 1",
        postalCode: "1234",
        city: "Oslo",
        countryCode: "NO"
      }
    })
  };
  const onVerifyImport = (event: any) => {
    setImportSheet(event.target.files[0]);
    const reader = new FileReader();
    reader.readAsDataURL(event.target.files[0]);
    reader.onload = () => {
      const excelFileBase64 = reader.result as string;
      makeRequest(`salesforce/ImportContractNumbers`, "PUT", excelFileBase64).then(result => {

      });
    };
  };
  const manuallyRunOrder = () => {
    makeRequest(`admin/action/manuallyRunOrder/`, "PUT", {
      orderId: orderId,
      orderType: orderType,
    }).then(result => {
      console.log(result);
    });
  }

  return (
    <Container
      className="container-fluid pt-4 px-0"
      maxWidth={false}
      sx={{ paddingBottom: '50px' }}>
      <Row>
        <Col>
          <Box
            component="div"
            className="pb-5">
            <SuccessButton onClick={handleUpdateSecretPage}> send test </SuccessButton>
            <label htmlFor="contained-button-file">
              <input
                accept=".xlsx, .xls"
                id="contained-button-file"
                multiple type="file"
                onChange={onVerifyImport}
                style={{ display: 'none' }}
              />

              <Button
                variant="contained"
                component="span">
                <Icon className='me-1' fontSize="small">add</Icon>{t("standard.uploadExcelFile")}
              </Button>

              <TextField
                onChange={(event) => { setOrderId(event.target.value); }}
                value={orderId}
                label={"OrdreId"}
              />
              <TextField
                onChange={(event) => { setOrderType(event.target.value); }}
                value={orderType}
                label={"OrdreType"}
              />
              <Button
                onClick={manuallyRunOrder}
                variant="contained"
              >
                <Icon className='me-1' fontSize="small">add</Icon>{"Manually run order"}
              </Button>
            </label>
            <PageTitle title={url !== pageEnums.page0 ? data.description : t("secretPage.selectPage")} />
            <Select
              value={url}
              onChange={(event: any) => { setUrl(event.target.value); }}>
              <MenuItem value={pageEnums.page0} key={pageEnums.page0}>{t("secretPage.selectPage")}</MenuItem>
              <MenuItem value={pageEnums.page1} key={pageEnums.page1}>side 1</MenuItem>
              <MenuItem value={pageEnums.page2} key={pageEnums.page2}>side 2</MenuItem>
              <MenuItem value={pageEnums.page3} key={pageEnums.page3}>side 3</MenuItem>
              <MenuItem value={pageEnums.page4} key={pageEnums.page4}>side 4</MenuItem>
              <MenuItem value={pageEnums.page5} key={pageEnums.page5}>orders</MenuItem>
              <MenuItem value={pageEnums.page6} key={pageEnums.page6}>orderProduct</MenuItem>
              <MenuItem value={pageEnums.page7} key={pageEnums.page7}>assets</MenuItem>
              <MenuItem value={pageEnums.page8} key={pageEnums.page8}>accounts</MenuItem>
              <MenuItem value={pageEnums.page9} key={pageEnums.page9}>contacts</MenuItem>
              <MenuItem value={pageEnums.page10} key={pageEnums.page10}>tasks</MenuItem>
              <MenuItem value={pageEnums.page11} key={pageEnums.page11}>events</MenuItem>
              <MenuItem value={pageEnums.page12} key={pageEnums.page12}>contracts</MenuItem>
            </Select>
            <WebkuaTable
              data={data.data}
              headers={headers}
            />
          </Box>
        </Col>
      </Row>
    </Container>
  );
}

export default SecretPage1;